import axios from 'axios'
import Environments from '../environments/Environment';

var http = null;

class APIProvider {
    constructor() {
        http = axios.create({
            baseURL: Environments.BASE_URL,
            headers: { 'Content-Type': 'application/json' },
        })
    }

    requestType(data) {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.put('/user/save/request-type', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    bureauConsult() {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.get('/bureau/consult').then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    validarCodigoBuro(data) {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post('/bureau/validar-codigo', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    createCreditQuotation(data) {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post('/user/create/credit-quotation', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }
    updateCreditQuotation(data) {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post('/user/update/credit-quotation', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    createBusinessPartner(data) {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post('/user/create/business-partner', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    getUser() {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.get('/user/get').then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }
    getUserReprentante() {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.get('/user/get/reprecentante').then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }
    getUserAval() {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.get('/user/get/aval').then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }
    getUserObligado() {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.get('/user/get/obligado').then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    getContract(){
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.get('/user/get/contract').then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    updateUser(data) {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post('/user/update', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    updateContract(data) {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post('/user/update/contract', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }
    updateFromTaskClickUp(data) {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post('user/update/task-clickup', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    getDetails() {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.get('/user/get/details').then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    getDocuments() {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.get('/user/get/documents').then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    getCreditQuotation() {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.get('/user/get/credit-quotation').then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        //location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    updateDetails(data) {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post('/user/update/details', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    getEmployement() {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.get('/user/get/employment').then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    updateEmployement(data) {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post('/user/update/employment', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    getAddress() {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.get('/user/get/address').then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    getReference() {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.get('/user/get/references').then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    updateAddress(data) {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post('/user/update/address', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    updateReference(data) {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post('/user/update/references', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    sendConfirmationCode(data) {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post('/user/confirmation/send', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    verifyConfirmationCode(data) {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post('/user/confirmation/verify', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

    uploapFileToClickUp(data){
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {

            let formData = new FormData();
            formData.append('file', data.data.files.file );
            formData.append('filename', data.data.files.name );
            formData.append('clickupTaskId', data.data.clickupTaskId);

            http.put( 'user/update/file-clickup',
            formData,
            {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            .then(function(result){
                success(result);
            })
            .catch(function(result){
                console.log("error",result);
                error(result);
            });
        });
    }

    uploapFileToFillIne(data){
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {

            let formData = new FormData();
            formData.append('file', data.data.files.file );
            formData.append('filename', data.data.files.name );

            http.put( 'user/update/get-fill-ine',
            formData,
            {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            .then(function(result){
                success(result);
            })
            .catch(function(result){
                console.log("error",result);
                error(result);
            });
        });
    }

    uploapFileUserDataToClickUp(){
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post( 'user/uploap/info-clickup',{})
                .then(function(result){
                    success(result);
                })
                .catch(function(result){
                    error(result);
                });
        });
    }
}

export default new APIProvider();



// WEBPACK FOOTER //
// ./src/services/User.js